<template>
  <div>
    <template v-for="(d, name, index) in filteredWp">
      <v-card :key="index" flat class="mb-6">
        <h4>{{ name }}</h4>
        <v-list>
          <v-list-item-group
            v-model="workplace"
            :multiple="actionType === 'checkbox' ? true : false"
            
          >
            <template v-for="(item, index) in d">
              <v-divider :key="`divider-${index}`" v-if="index != 0"></v-divider>

              <v-list-item :key="`item-${index}`" @click="$emit('item-clicked', item)">
                <v-list-item-icon v-if="icon">
                  <v-icon>{{ icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="height-large" :class="icon ? 'ml-4' : ''">
                  <v-list-item-title v-html="item.name"></v-list-item-title>
                  <v-list-item-subtitle
                    >{{ item.postalAddress1 }}, {{ item.postalZip }} {{ item.postalCity }}
                    <span v-if="withApprenticesQty">({{ item.numApprenticeships }})</span>
                    <slot name="custom-text" v-bind="item"></slot>
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-icon v-if="actionIcon">
                  <div v-if="withExplanation" class="workplace-icons">
                    <v-list-item-icon class="mr-n2" v-if="item.isDeliveryWorkplace">
                      <v-icon>$sl-delivery</v-icon>
                    </v-list-item-icon>
                    <v-list-item-icon v-if="item.isInvoiceWorkplace">
                      <v-icon>$sl-invoice</v-icon>
                    </v-list-item-icon>
                  </div>

                  <v-icon>{{ actionIcon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-icon v-if="actionType === 'checkbox'">
                  <v-checkbox v-model="workplace" :value="item.id"> </v-checkbox>
                </v-list-item-icon>
                <v-list-item-action v-if="actionType === 'select'">
                  <div class="v-list-item__radio">
                    <input type="radio" v-model="workplace" :value="item.id" />
                    <div class="check">
                      <div class="inside"></div>
                    </div>
                  </div>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
      </v-card>
    </template>
    <div v-if="withExplanation" class="mt-5 workplaces__icons--explanation">
      <p class="overline small">{{ $t('company.explanation') }}</p>
      <p class="caption mt-n2"><v-icon class="mr-2">$sl-invoice</v-icon>{{ $t('application.company.text-invoice') }}</p>
      <p class="caption mt-n4">
        <v-icon class="mr-2">$sl-delivery</v-icon>{{ $t('application.company.text-delivery') }}
      </p>
      <p class="caption mt-n1" style="margin-left: 26px">{{ $t('application.company.text-apprentice') }}</p>
    </div>
  </div>
</template>

<script>
import API from '@/services/api.js'
import find from 'lodash/find'
import groupBy from 'lodash/groupBy'
import {forEach} from 'lodash'

export default {
  name: 'WorkplacesListItems',
  props: {
    filteredWp: {
      type: Object,
      required: true
    },
    withApprenticesQty: {
      type: Boolean,
      required: false,
      default: false
    },
    model: {
      type: [Array, Number],
      required: false
    },
    actionType: {
      type: String,
      required: false
    },
    withSearch: {
      type: Boolean,
      required: false,
      default: false
    },
    withExplanation: {
      type: Boolean,
      required: false,
      default: false
    },
    flat: {
      type: Boolean,
      required: false,
      default: false
    },
    icon: {
      type: String,
      required: false
    }
  },
  data: function () {
    return {
      workplace: this.model,
      departments: [],
      tab: null,
      depArray: []
    }
  },
  watch: {
    model() {
      this.workplace = this.model
    }
  },
  created() {
    
  },
  methods: {
    // listDepartments() {
    //   if (!(this.$route && this.$route.params && this.$route.params.id)) return

    //   API.listDepartments(this.$route.params.id)
    //     .then(response => {
    //       console.log('listDep', response.data)
    //       this.depArray = response.data
    //     })
    //     .catch(error => {
    //       console.log('There was an error:', error)
    //     })
    // }
  },
  computed: {
    actionIcon() {
      switch (this.actionType) {
        case 'view':
          return '$sl-arrow-right'
        case 'unlink':
          return '$sl-unlink'
        case 'checkbox':
        case 'select':
        default:
          return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.workplace-icons {
  transform: scale(0.75);
  margin: 0;
  display: flex;
}
</style>